export default {"src":"/_next/static/media/XLSX.811f3abf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};